import React from 'react';
import ListDocuments from './ListDocuments';


function Documents() {
  return <ListDocuments />;
}

export default Documents;
